const TAP_TOUCH_DURATION = 200
const TAP_PIXEL_THRESHOLD = 10

type TapElement = HTMLElement & {
  _tapDirectiveCleanup?: () => void
}

const tapDirective = {
  name: 'tap',
  mounted(element: TapElement, binding: any) {
    let touchStartTime = 0
    let tapTimeout: number | undefined
    let startX = 0
    let startY = 0

    const handleTouchStart = (event: TouchEvent) => {
      touchStartTime = new Date().getTime()
      const touch = event.touches[0]

      startX = touch.clientX
      startY = touch.clientY
    }

    const handleTouchEnd = (event: TouchEvent) => {
      const touchEndTime = new Date().getTime()
      const touchDuration = touchEndTime - touchStartTime

      const touch = event.changedTouches[0]
      const endX = touch.clientX
      const endY = touch.clientY
      const deltaX = Math.abs(endX - startX)
      const deltaY = Math.abs(endY - startY)

      if (touchDuration < TAP_TOUCH_DURATION && deltaX < TAP_PIXEL_THRESHOLD && deltaY < TAP_PIXEL_THRESHOLD) {
        if (typeof binding.value === 'function') {
          binding.value(event)
        }
      }
    }

    element.addEventListener('touchstart', handleTouchStart)
    element.addEventListener('touchend', handleTouchEnd)

    element._tapDirectiveCleanup = () => {
      element.removeEventListener('touchstart', handleTouchStart)
      element.removeEventListener('touchend', handleTouchEnd)

      if (tapTimeout) {
        clearTimeout(tapTimeout)
      }
    }
  },
  beforeUnmount(element: TapElement) {
    if (element._tapDirectiveCleanup) {
      element._tapDirectiveCleanup()
    }
  },
}

export default tapDirective
